import * as React from 'react';
import { SVGProps } from 'react';

const IconClearSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0-8.273 2.466-2.467a.9.9 0 0 1 1.273 1.273L9.271 8.001l2.466 2.469a.9.9 0 1 1-1.272 1.273L8 9.275l-2.464 2.468a.9.9 0 1 1-1.273-1.273l2.465-2.469-2.465-2.468A.9.9 0 0 1 5.536 4.26L8 6.727Z"
    />
  </svg>
);
export default IconClearSizeS;
